module.exports = __webpack_public_path__ + "media/images/icons/country_flags/hn-2427006aada8b474df115cb6508daf42.svg";